import { api } from './api';

// Define a service using a base URL and expected endpoints
export const analyticsApi = api.injectEndpoints({
  reducerPath: 'analyticsApi',
  tagTypes: ['Terms', 'TopOccurenceTerms'],
  endpoints: (builder) => ({
    suggestTerms: builder.query({
      query: ({ query, maxResult = 5 }) => ({
        url: `/public/api/entities/search/suggestTerms?query=${query}&maxResult=${maxResult}`,
        method: 'GET'
      }),
      providesTags: () => ['Terms']
    }),
    topOccurenceTerms: builder.query({
      query: ({ maxResult = 25 }) => ({
        url: `/public/api/entities/search/topOccurrenceTerms?maxResult=${maxResult}`,
        method: 'GET'
      }),
      providesTags: () => ['TopOccurenceTerms']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSuggestTermsQuery, useTopOccurenceTermsQuery } = analyticsApi;
